import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MatrixPortal from "./pages/MatrixPortal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MatrixPortal variant="zae" />} />
          <Route path="/TomzaAccion" element={<MatrixPortal variant="tomza" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
